export const ICE_SERVERS: RTCIceServer[] = [
  { urls: 'stun:stun.relay.metered.ca:80' },
  {
    urls: 'turn:global.relay.metered.ca:80',
    username: '6c23dabd2e0a1d3c63457162',
    credential: 'oCemAkWMv/z1Betv',
  },
  {
    urls: 'turn:global.relay.metered.ca:80?transport=tcp',
    username: '6c23dabd2e0a1d3c63457162',
    credential: 'oCemAkWMv/z1Betv',
  },
  {
    urls: 'turn:global.relay.metered.ca:443',
    username: '6c23dabd2e0a1d3c63457162',
    credential: 'oCemAkWMv/z1Betv',
  },
  {
    urls: 'turns:global.relay.metered.ca:443?transport=tcp',
    username: '6c23dabd2e0a1d3c63457162',
    credential: 'oCemAkWMv/z1Betv',
  },
];
